import { FC, memo } from "react";

import FloorPlan from "./FloorPlan";
import GenericService from "./GenericService";
import ImagemotionVideo from "./ImagemotionVideo";
import { ORDERSERVICE_TYPE } from "@/types";
import OfferedService from "./OfferedService";
import { OrderServiceCardProps } from "./OrderService.interface";
import Photo from "./Photo";
import VirtualStaging from "./VirtualStaging";
import VirtualTour from "./VirtualTour";
import WalklyService from "./WalklyService";
import { getGroupedOrderServices } from "@/helpers";

const OrderServiceCard: FC<OrderServiceCardProps> = ({
  isWorker,
  offeredServices,
  onAskToChangeWorker,
  onChangeLabel,
  onChangeUrl,
  services,
  ...events
}) => {
  
  const { photoService: service , floorPlanService, virtualTourService, virtualStagingService, imagemotionVideoService, walklyService, remainingServices } = getGroupedOrderServices(services);

  const filteredOfferedServices = offeredServices.filter((value, index, self) => {
    return index === self.findIndex((t) => t.name === value.name)
  });

  return (
    <>
      {service && (
        <Photo
          {...events}
          amount={service.amount}
          draftFiles={service.draftUploadFiles}
          isWorker={isWorker}
          name={service.name}
          notificationMessage={service.notificationMessage}
          onAskToChangeWorker={onAskToChangeWorker}
          selectedWorkerName={service.applicationUserName}
          serviceId={service.orderServiceId}
          type={service.type}
          uploadedFiles={service.uploadFiles}
        />
      )}

      {floorPlanService && (
        <FloorPlan
          {...events}
          amount={floorPlanService.amount}
          draftFiles={floorPlanService.draftUploadFiles}
          isWorker={isWorker}
          name={floorPlanService.name}
          notificationMessage={floorPlanService.notificationMessage}
          onAskToChangeWorker={onAskToChangeWorker}
          selectedWorkerName={floorPlanService.applicationUserName}
          serviceId={floorPlanService.orderServiceId}
          type={floorPlanService.type}
          uploadedFiles={floorPlanService.uploadFiles}
        />
      )}

      {virtualTourService && (
        <VirtualTour
          {...events}
          amount={virtualTourService.amount}
          draftFiles={virtualTourService.draftUploadFiles}
          name={virtualTourService.name}
          notificationMessage={virtualTourService.notificationMessage}
          onAskToChangeWorker={onAskToChangeWorker}
          selectedWorkerName={virtualTourService.applicationUserName}
          serviceId={virtualTourService.orderServiceId}
          type={virtualTourService.type}
          uploadedFiles={virtualTourService.uploadFiles}
        />
      )}

      {virtualStagingService && (
        <VirtualStaging
          {...events}
          amount={virtualStagingService.amount}
          draftFiles={virtualStagingService.draftUploadFiles}
          name={virtualStagingService.name}
          notificationMessage={virtualStagingService.notificationMessage}
          onAskToChangeWorker={onAskToChangeWorker}
          onChangeUrl={onChangeUrl}
          selectedWorkerName={virtualStagingService.applicationUserName}
          serviceId={virtualStagingService.orderServiceId}
          type={virtualStagingService.type}
          uploadedFiles={virtualStagingService.uploadFiles}
        />
      )}

      {imagemotionVideoService && (
        <ImagemotionVideo
          {...events}
          amount={imagemotionVideoService.amount}
          draftFiles={imagemotionVideoService.draftUploadFiles}
          name={imagemotionVideoService.name}
          notificationMessage={imagemotionVideoService.notificationMessage}
          onAskToChangeWorker={onAskToChangeWorker}
          selectedWorkerName={imagemotionVideoService.applicationUserName}
          serviceId={imagemotionVideoService.orderServiceId}
          type={imagemotionVideoService.type}
          uploadedFiles={imagemotionVideoService.uploadFiles}
        />
      )}

      { walklyService && (
        <WalklyService
        {...events}
          amount={walklyService.amount}
          externalUrl={walklyService.externalLink || ''}
          label={walklyService.label || ''}
          name={walklyService.name}
          notificationMessage={walklyService.notificationMessage}
          onAskToChangeWorker={onAskToChangeWorker}
          onChangeUrl={onChangeUrl}
          selectedWorkerName={walklyService.applicationUserName}
          serviceId={walklyService.orderServiceId}
          type={walklyService.type}
        />
      )}

      {remainingServices.map((item) => {
        return (
          <GenericService
            key={item.orderServiceId}
            {...events}
              amount={item.amount}
              label={item.label ||''}
              externalUrl={item.externalLink || ''}
              name={item.name}
              notificationMessage={item.notificationMessage}
              onAskToChangeWorker={onAskToChangeWorker}
              onChangeLabel={onChangeLabel}
              onChangeUrl={onChangeUrl}
              selectedWorkerName={item.applicationUserName}
              serviceId={item.orderServiceId}
              type={item.type}
            />
        );
      })}

      {filteredOfferedServices.map((item) => {
        return (
          <OfferedService
              key={item.offeredServiceId}
              {...events}
              isOffered
              logoUrl={''}
              name={item.name}
              onAskToChangeWorker={onAskToChangeWorker}
              selectedWorkerName={''}
              serviceId={item.offeredServiceId}
              type={item.type}
              uploadedFiles={item.uploadFiles}
            />
        );
      })}
    </>
  );
};

export default memo(OrderServiceCard);